module.exports = __webpack_public_path__ + "img/logo-dashboard.ca89506c.svg";